import React from 'react'
import { Modal } from 'components/reusables/modal'
import { ModalButtons } from 'components/reusables/modalButtons'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { ModalBodyText } from './styled'

interface ConfirmInactivateCourseModalProps {
  isOpen: boolean
  processing?: boolean
  inProgress: number
  notStarted: number
  onClose: () => void
  onConfirm: () => void
}

export const ConfirmInactivateCourseModal: React.FC<ConfirmInactivateCourseModalProps> =
  ({
    isOpen,
    processing = false,
    inProgress,
    notStarted,
    onClose,
    onConfirm,
  }) => {
    const t = useTranslationRankmi({
      prefix: 'administration.courses.edit.confirmInactiveModal',
    })

    return (
      <Modal
        isOpen={isOpen}
        title={t('title')}
        isConfirmation
        maxwidth={640}
        maxheight={320}
        close={onClose}
        actions={
          <ModalButtons
            secondaryText={t('cancel')}
            secondaryAction={onClose}
            disableSecondaryButton={processing}
            primaryText={t('confirm')}
            primaryAction={onConfirm}
            disablePrimaryButton={processing}
            processing={processing}
          />
        }
      >
        <ModalBodyText>{t('body', { inProgress, notStarted })}</ModalBodyText>
      </Modal>
    )
  }

export default ConfirmInactivateCourseModal
